import { InputNumber } from "antd";
import { InputNumberProps } from "antd";
import classNames from "classnames";
import { FieldWrapper } from "components/UI/Table/UI/InteractiveCell/components/FieldWrapper.tsx";
import { WithSaveButton } from "components/UI/Table/UI/InteractiveCell/components/WithSaveButton.tsx";
import { useInteractiveCell } from "components/UI/Table/UI/InteractiveCell/hooks/useInteractiveCell.ts";
import { FieldProps } from "components/UI/Table/UI/InteractiveCell/miscs/types.ts";
import { FieldValues } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";

type Props<T extends FieldValues> = InputNumberProps & FieldProps<T>;

export const WithInputNumber = <T extends FieldValues = FieldValues>({ formControl, ...props }: Props<T>) => {
    const { onChange, onSave, value, className, ...restProps } = props;

    const {
        setControlledValue,
        handleOnSaveSideEffects,
        resolvedValue,
        isFormControlled,
        handleFocus,
        handleBlur,
        fieldRef,
        error,
    } = useInteractiveCell({
        formControl,
        value,
    });

    const handleChange: InputNumberProps["onChange"] = (value) => {
        setControlledValue(value);
        onChange?.(value);
    };

    const handleSave = () => {
        handleOnSaveSideEffects();
        onSave?.(resolvedValue);
    };

    return (
        <FieldWrapper
            displayValue={resolvedValue}
            ref={fieldRef}
            isError={!!error}
            errorMessage={error?.message as string}
        >
            <WithSaveButton onSave={handleSave}>
                {isFormControlled ? (
                    <FormItem {...(formControl as NonNullable<typeof formControl>)} noStyle>
                        <InputNumber
                            {...restProps}
                            className={classNames(className, "!w-full")}
                            onBlur={handleBlur}
                            onFocus={handleFocus}
                        />
                    </FormItem>
                ) : (
                    <InputNumber
                        {...restProps}
                        onChange={handleChange}
                        className={classNames(className, "!w-full")}
                        value={resolvedValue as InputNumberProps["value"]}
                        onBlur={handleBlur}
                        onFocus={handleFocus}
                    />
                )}
            </WithSaveButton>
        </FieldWrapper>
    );
};
